import { useCallback } from 'react';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { ProjectsView } from '@/components/projects/ProjectsView';
import type { AppShellContext } from '@/components/layout/AppShell';

export function ProjectsPage() {
  const { nip } = useParams<{ nip: string }>();
  const { companyName } = useOutletContext<AppShellContext>();
  const navigate = useNavigate();

  const handleProjectSelect = useCallback(
    (projectId: string) => {
      navigate(`/${nip}/projects/${projectId}`);
    },
    [nip, navigate],
  );

  return (
    <ProjectsView
      companyNip={nip || ''}
      companyName={companyName}
      onProjectSelect={handleProjectSelect}
    />
  );
}
